import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useContext, useRef, useState, useLayoutEffect } from 'react';
import { useOverlayPosition, mergeProps, useTooltip } from 'react-aria';
import { TooltipTriggerStateContext } from 'react-aria-components';
import { OverlayArrowContext } from '../../popover/aria/overlay-arrow.esm.js';
import { useEnterAnimation, useRenderProps } from '../../utils/index.esm.js';

function TooltipInner(props) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var state = useContext(TooltipTriggerStateContext);

  // Calculate the arrow size internally
  // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
  var arrowRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    arrowWidth = _useState2[0],
    setArrowWidth = _useState2[1];
  useLayoutEffect(function () {
    if (arrowRef.current && state.isOpen) {
      setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }
  }, [state.isOpen, arrowRef]);
  var _useOverlayPosition = useOverlayPosition({
      placement: props.placement || 'top',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      targetRef: props.triggerRef,
      overlayRef: props.tooltipRef,
      offset: props.offset,
      crossOffset: props.crossOffset,
      isOpen: state.isOpen,
      arrowSize: arrowWidth,
      arrowBoundaryOffset: props.arrowBoundaryOffset,
      shouldFlip: props.shouldFlip
    }),
    overlayProps = _useOverlayPosition.overlayProps,
    arrowProps = _useOverlayPosition.arrowProps,
    placement = _useOverlayPosition.placement;
  var isEntering = useEnterAnimation(props.tooltipRef, !!placement) || props.isEntering || false;
  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
    defaultClassName: 'react-aria-Tooltip',
    values: {
      placement: placement,
      isEntering: isEntering,
      isExiting: props.isExiting,
      state: state
    }
  }));
  props = mergeProps(props, overlayProps);
  var _useTooltip = useTooltip(props, state),
    tooltipProps = _useTooltip.tooltipProps;
  return /*#__PURE__*/React.createElement("div", _extends({}, tooltipProps, {
    ref: props.tooltipRef
  }, renderProps, {
    style: _objectSpread2(_objectSpread2({}, overlayProps.style), renderProps.style),
    "data-placement": placement,
    "data-entering": isEntering || undefined,
    "data-exiting": props.isExiting || undefined
  }), /*#__PURE__*/React.createElement(OverlayArrowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, arrowProps), {}, {
      placement: placement,
      ref: arrowRef
    })
  }, renderProps.children));
}

export { TooltipInner as default };
//# sourceMappingURL=tooltip-inner.esm.js.map
